import { AnyAction, PayloadAction } from '@reduxjs/toolkit'

export const HYDRATE = 'HYDRATE' as const
export function hydrateMatcher(action: AnyAction): boolean {
  return action.type === HYDRATE
}
export type HydrateAction<T> = PayloadAction<T, typeof HYDRATE>
